import React, { forwardRef, memo } from 'react'

const StarIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56.7"
      height="56"
      viewBox="0 0 56.7 56"
      fill="none"
      {...props}>
      <circle
        cx="28.175"
        cy="28"
        r="26.871"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="2.259"
      />
      <path
        d="M28.175 33.3454L33.063 36.2898C33.1872 36.3652 33.331 36.4021 33.4762 36.3978C33.6214 36.3935 33.762 36.3483 33.8787 36.2645C33.9953 36.1807 34.0831 36.062 34.1349 35.9633C34.1867 35.8646 34.2009 35.7396 34.1585 35.4874L32.7565 30.0106L36.9938 26.3183C37.1264 26.2229 37.2287 26.098 37.2908 25.9544C37.353 25.8108 37.3725 25.6546 37.3475 25.5058C37.3225 25.357 37.2549 25.2228 37.1522 25.1214C37.0495 25.0201 36.9166 24.9566 36.7746 24.9436L30.0065 24.57L28.8522 21.3551C28.7973 21.2205 28.7065 21.1024 28.5929 21.0213C28.4793 20.9402 28.3476 20.9 28.215 20.9C28.0824 20.9 27.9507 20.9402 27.8371 21.0213C27.7235 21.1024 27.6327 21.2205 27.5778 21.3551L26.4235 24.57L19.6553 24.9436C19.5125 24.9578 19.3785 25.0209 19.2635 25.1212C19.1485 25.2215 19.0799 25.3556 19.0517 25.5069C19.0235 25.6582 19.026 25.814 19.0682 25.958C19.1104 26.102 19.1901 26.2276 19.3322 26.3227L23.5695 30.0147L22.1675 35.4874C22.1251 35.7396 22.1393 35.8646 22.1911 35.9633C22.2429 36.062 22.3307 36.1807 22.4473 36.2645C22.564 36.3483 22.7045 36.3935 22.8498 36.3978C22.995 36.4021 23.1388 36.3652 23.263 36.2898L28.175 33.3454Z"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

StarIcon.displayName = 'StarIcon'

export default memo(StarIcon)
